import { useEffect, useState } from 'react';
import { bookPageService } from '@/api/services';
import { usePublicCatalogData } from '@/components/PublicCatalogData';

/**
 * Loads public visibility toggles for a book section row even when the section is inactive,
 * so the site can still honour e.g. show_search_form without exposing full CMS content.
 */
export function useBookPageSectionFlags(sectionKey) {
  const catalog = usePublicCatalogData();
  const contextFlags = sectionKey && catalog?.bookFlags ? catalog.bookFlags[sectionKey] : undefined;
  const hasContext = sectionKey ? Object.prototype.hasOwnProperty.call(catalog?.bookFlags || {}, sectionKey) : false;
  const [flags, setFlags] = useState(hasContext ? contextFlags ?? null : null);
  const [loading, setLoading] = useState(Boolean(sectionKey) && !hasContext);

  useEffect(() => {
    if (!sectionKey) {
      setFlags(null);
      setLoading(false);
      return;
    }
    if (hasContext) {
      setFlags(contextFlags ?? null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    bookPageService
      .getSectionFlagsByKey(sectionKey)
      .then((res) => {
        if (cancelled) return;
        setFlags(res.data?.data ?? null);
      })
      .catch(() => {
        if (!cancelled) setFlags(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [sectionKey, hasContext, contextFlags]);

  return { flags, loading };
}

export default useBookPageSectionFlags;
